import React, { Component } from 'react';
import { Role } from '../../_helpers/role';
import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { searchIntake } from '../../_actions/intake.action'

import moment from 'moment';
import DataTable from 'react-data-table-component';
import queryString from 'query-string';
import IntakeEmpty from './Empty';
import DownloadLink from './DownloadLink';
import ExportIntake from './ExportComponent'
import SearchFilters from './SearchFilters';
import DetailComponent from './DetailComponent';

import { Can } from '../../_contexts/AbilitiesContext';

const columns = [
  {
    name: 'Status',
    sort: false,
    cell: intake => {
      return <span className='badge badge-info text-uppercase'>{intake.status.replace('_', ' ')}</span>
    }
  },
  {
    name: 'Patient',
    sort: false,
    cell: intake => `${intake.firstName} ${intake.lastName}`
  },
  {
    name: 'Completed On',
    sort: false,
    cell: row => {
      return row.completedAt ? moment.tz(row.completedAt.date, row.completedAt.timezone).local().format('l LT') : ''
    }
  },
  {
    name: 'Provider',
    sort: false,
    cell: intake => `${intake.doctor.firstName} ${intake.doctor.lastName}`
  },
  {
    name: 'Location',
    sort: false,
    cell: intake => intake.providerGroup.name
  },
  {
    name: 'Questionnaire',
    sort: false,
    cell: intake => intake.questionnaire.title
  },
  {
    button: true,
    sort: false,
    cell: (intake) => {
      if (intake.status === 'COMPLETED') {
        return <DownloadLink intake={intake} small />
      }
    }
  }
];

class Intake extends Component {
  constructor(props) {
    super(props);

    this.state = {
      initLoad: true,
    }
    this.loadData = this.loadData.bind(this);
  }

  componentDidMount() {
    const { currentUser } = this.props;

    if (currentUser.UserType.Name === 'Licensed') {
      const providerId = currentUser.Doctor.DoctorId;
      this.props.history.push(`/intake?professional=${providerId}&time=${Date.now()}`)
    } else {
      this.loadData();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      if (this.state.initLoad && this.props.collection.length > 0) {
        this.setState({ initLoad: false })
      }
      this.loadData();
    }
  }

  loadData() {
    const searchParams = this.searchParams();

    this.props.dispatch(searchIntake(searchParams));
  }

  searchParams() {
    const queryParams = queryString.parse(this.props.location.search);
    const showDateRange = ("completedOnStart" in queryParams) ? true : false;

    return {
      page: queryParams.page || 1,
      firstName: queryParams.firstName || '',
      lastName: queryParams.lastName || '',
      groupId: queryParams.location ? parseInt(queryParams.location) : '',
      providerId: queryParams.professional ? parseInt(queryParams.professional) : '',
      status: queryParams.status || '',
      completedOn: !showDateRange ? queryParams.completedOn || '' : '',
      completedOnStart: showDateRange ? queryParams.completedOnStart || '' : '',
      completedOnEnd: showDateRange ? queryParams.completedOnEnd || '' : '',
      questionnaireId: queryParams.questionnaire ? parseInt(queryParams.questionnaire) : '',
    }
  }

  render() {
    const { isLoading, collection, total, alert } = this.props;

    return <div className="container-fluid mt-4">
      {alert.message &&
        <div className={`alert ${alert.type}`}>{alert.message}</div>
      }
      <div className="row">
        <div className="col-lg-10 offset-lg-2">
          <div className="row">
            <div className="col-lg-6">
              <h1 className="h2"><i className="fa fa-filter" aria-hidden="true"></i> Intake</h1>
            </div>

            <Can I="export" a="form">
              <div className="col-lg-6">
                <div className="row" style={{ justifyContent: "flex-end" }}>
                  <div className="col-lg-auto">
                    <ExportIntake />
                  </div>
                </div>
              </div>
            </Can>

          </div>
        </div>

        <div className="col-lg-12 mt-3">
          <div className="row">
            <div className="col-lg-2">
              <SearchFilters location={this.props.location} handleSearch={(params) => {
                const { firstName, lastName, location, professional, status, completedOn, completedOnStart, completedOnEnd, questionnaire, showDateRange } = params;

                const startDate = completedOnStart ? moment(completedOnStart).format("L") : '';
                const endDate = completedOnEnd ? moment(completedOnEnd).format("L") : '';

                this.props.history.replace(`/intake?firstName=${firstName}&lastName=${lastName}${showDateRange ? `&completedOnStart=${startDate}&completedOnEnd=${endDate}` : `&completedOn=${completedOn}`}&location=${location}&professional=${professional}&status=${status}&questionnaire=${questionnaire}`)
              }} />
            </div>
            <div className="col-lg-10">
              {isLoading && this.state.initLoad ?
                <Spinner animation="border" role="status" />
                :
                this.state.initLoad && collection.length === 0 ?
                  <IntakeEmpty />
                  :
                  <DataTable
                    noHeader
                    columns={columns}
                    data={collection}
                    progressPending={isLoading}
                    onChangePage={page => {
                      const queryParams = queryString.parse(this.props.location.search);
                      const showDateRange = ("completedOnStart" in queryParams) ? true : false;

                      const firstName = queryParams.firstName || '';
                      const lastName = queryParams.lastName || '';
                      const location = queryParams.location ? parseInt(queryParams.location) : '';
                      const professional = queryParams.professional ? parseInt(queryParams.professional) : '';
                      const status = queryParams.status || '';
                      const completedOn = queryParams.completedOn || '';
                      const completedOnStart = queryParams.completedOnStart || '';
                      const completedOnEnd = queryParams.completedOnEnd || '';
                      const questionnaire = queryParams.questionnaire ? parseInt(queryParams.questionnaire) : '';

                      this.props.history.replace(`/intake?page=${page}firstName=${firstName}&lastName=${lastName}${showDateRange ? `&completedOnStart=${completedOnStart}&completedOnEnd=${completedOnEnd}` : `&completedOn=${completedOn}`}&location=${location}&professional=${professional}&status=${status}&questionnaire=${questionnaire}`)
                    }}
                    striped={true}
                    pagination={true}
                    paginationServer={true}
                    paginationTotalRows={total}
                    paginationRowsPerPageOptions={[15]}
                    paginationPerPage={15}
                    expandableRows
                    expandOnRowClicked
                    expandableRowsComponent={<DetailComponent />}
                    noDataComponent={<div className="p-4">We could not find any results based on your search criteria</div>}
                    customStyles={{ cells: { style: { fontSize: '14px' }, }, }}
                  />
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

function mapStateToProps(state) {
  return {
    alert: state.alert,
    total: state.intake.collection.collection ? state.intake.collection.total : 0,
    isLoading: state.intake.isLoading,
    collection: state.intake.collection.collection ? state.intake.collection.collection.data : [],
    currentUser: state.user.currentUser,
  };
}

export default connect(mapStateToProps)(Intake);